export const SAVE_TIP_COOKIE_NAME = "rp_save_tip";
export const SAVE_TIP_SEEN = "seen";
